import { render, staticRenderFns } from "./TagCheckbox.vue?vue&type=template&id=7e554a5b"
import script from "./TagCheckbox.vue?vue&type=script&lang=js"
export * from "./TagCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports